module.exports = {"542431100":"措折罗玛镇","542431200":"协德乡","542431201":"雅曲乡","542431202":"嘎措乡","542431203":"措折强玛乡","542431204":"多玛乡","542431205":"巴岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542431.json
// module id = 2904
// module chunks = 0